import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { FileDto } from '@shared/service-proxies/service-proxies';
import { Observable, flatMap, of } from 'rxjs';

@Injectable()
export class FileDownloadService {
    private http: HttpClient;
    constructor(@Inject(HttpClient) http: HttpClient) {
        this.http = http;
    }
    downloadTempFile(file: FileDto) {
        const url =
            AppConsts.remoteServiceBaseUrl +
            '/File/DownloadTempFile?fileType=' +
            file.fileType +
            '&fileToken=' +
            file.fileToken +
            '&fileName=' +
            file.fileName;
        location.href = url; //TODO: This causes reloading of same page in Firefox
    }

    downloadFile(url: string, fileName: string, fileExtension?: string): Observable<any> {
        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": "Bearer " + abp.auth.getToken(),
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url, options_)
            .pipe(flatMap((xhr: any) => {
                if (xhr.status == 200) {
                    // TODO: Check
                    if ((navigator as any).msSaveOrOpenBlob) { //IE supported download
                        (navigator as any).msSaveOrOpenBlob(xhr.body, fileName + fileExtension);
                    } else { //All other browers supported download
                        var downloadUrl = URL.createObjectURL(xhr.body);
                        var a = document.createElement("a");
                        a.href = downloadUrl;
                        a.download = fileName + fileExtension;
                        document.body.appendChild(a);
                        a.click();
                    }
                    return of('Success');
                }
            }));
    }
}
